import { reactive } from "vue";

/** 后端 500 响应携带的异常详情（对应后端 ApiErrorDetail） */
export interface ApiErrorDetail {
  /** 错误编号：运维凭此编号在系统错误日志/数据库定位 */
  errorNo?: string;
  /** 链路追踪编号（SkyWalking traceId），可能为空 */
  traceId?: string;
  /** 发生异常的服务名 */
  applicationName?: string;
  /** 请求方法 */
  requestMethod?: string;
  /** 请求地址 */
  requestUrl?: string;
  /** 操作人编号 */
  userId?: number;
  /** 操作人 IP */
  userIp?: string;
  /** 异常类名 */
  exceptionName?: string;
  /** 异常消息 */
  exceptionMessage?: string;
  /** 异常发生类名（堆栈首帧） */
  exceptionClassName?: string;
  /** 异常发生文件名（堆栈首帧） */
  exceptionFileName?: string;
  /** 异常发生方法名（堆栈首帧） */
  exceptionMethodName?: string;
  /** 异常发生行号（堆栈首帧） */
  exceptionLineNumber?: number;
  /** 堆栈摘要（仅内网 prem 部署返回） */
  stackTrace?: string;
  /** 异常发生时间（yyyy-MM-dd HH:mm:ss） */
  exceptionTime?: string;
}

export const errorDetailState = reactive({
  visible: false,
  detail: null as ApiErrorDetail | null,
});

/** 打开错误详情弹窗（由请求拦截器遇到 500 时调用） */
export const openErrorDetail = (detail: ApiErrorDetail): void => {
  errorDetailState.detail = detail;
  errorDetailState.visible = true;
};
